import { cn } from '@/utils/cn';

export const LinkedInLogo = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={cn('w-6', className)}
			viewBox="0 0 20 20"
			fill="none"
		>
			<path
				d="M16.8157 2H3.18091C2.52937 2 2 2.51646 2 3.15291V16.8451C2 17.4823 2.52937 17.9995 3.18091 17.9995H16.8157C17.4683 17.9995 18 17.4823 18 16.8451V3.15291C18 2.51645 17.4683 2 16.8157 2ZM6.74537 15.6337H4.37223V7.99817H6.74537V15.6337ZM5.55931 6.9544C4.79874 6.9544 4.18308 6.33783 4.18308 5.57829C4.18308 4.81932 4.79874 4.20275 5.55931 4.20275C6.31805 4.20275 6.93451 4.81932 6.93451 5.57829C6.93451 6.33783 6.31805 6.9544 5.55931 6.9544ZM15.6338 15.6337H13.2624V11.9205C13.2624 11.0351 13.2462 9.89611 12.0293 9.89611C10.7945 9.89611 10.6049 10.8607 10.6049 11.8565V15.6337H8.23395V7.99817H10.5099V9.04148H10.5417C10.8586 8.44125 11.6327 7.80834 12.7871 7.80834C15.1902 7.80834 15.6338 9.38994 15.6338 11.4456V15.6337Z"
				fill="currentColor"
			/>
		</svg>
	);
};
